import { Morakasi } from './../../Model/dbo/Morakasi';
import { useEffect, useState } from "react";
import axios from 'axios';
import Cookies from 'universal-cookie';
import { BaseApi } from './BaseUrl'
import { promises } from 'fs';
import { PersonelComment } from '../../Model/dbo/Comment';
import { SurveyItem } from '../../Model/dbo/Survey';

export async function GetAllMorakasiForUser(): Promise<Array<Morakasi>> {
  try {
    var user = new Cookies().get('user');
    const requestOptions = {
      headers: { 'Authorization': user.Token }
    };
    const response = await axios.get(BaseApi + 'HR/GetAllMorakasiForPerson', requestOptions);
    return response.data;
  }
  catch (error) {
    console.error(error);
    return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
  }
}

export async function GetAllMorakasiConfirmForUser(): Promise<Array<Morakasi>> {
  try {
    var user = new Cookies().get('user');
    const requestOptions = {
      headers: { 'Authorization': user.Token }
    };
    const response = await axios.get(BaseApi + 'HR/GetAllMorakasiConfirmForUser', requestOptions);
    return response.data;
  }
  catch (error) {
    console.error(error);
    return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
  }
}
export async function ConfirmMorakasiForUser(id: number, pid: number, confirmstatus: boolean): Promise<boolean> {
  try {
    var user = new Cookies().get('user');
    const requestOptions = {
      headers: { 'Authorization': user.Token }
    };
    const response = await axios.get(BaseApi + 'HR/ConfirmMorakasi?id=' + id + '&personelid=' + pid + '&confirmstatus=' + confirmstatus, requestOptions)
    return response.data;
    // می‌توانید state را به‌روزرسانی کنید یا کاربر را هدایت کنید
  }
  catch (error) {
    console.error(error);
    return false; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
  }

}
export async function DELMorakasiForUser(id: number, pid: number): Promise<boolean> {
  try {
    var user = new Cookies().get('user');
    console.log(user)
    const requestOptions = {
      headers: { 'Authorization': user.Token }
    };
    const response = await axios.get(BaseApi + 'HR/DelMorakasi?id=' + id + '&personelid=' + pid, requestOptions)
    return response.data;
  }
  catch (error) {
    console.error(error);
    return false; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
  }
}
export async function ADDMorakasiForUser(morakhasidatestart: string, morakhasidateend: string, stime: string, etime: string): Promise<boolean> {
  try {
    var user = new Cookies().get('user');
    const requestOptions = {
      headers: { 'Authorization': user.Token }
    };
    const response = await axios.get(BaseApi + 'HR/AddMorakasi?morakhasisdate=' + morakhasidatestart + '&morakhasiedate=' + morakhasidateend + '&stime=' + stime + '&etime=' + etime, requestOptions)
    return response.data;
  }
  catch (error) {
    console.error(error);
    return false; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
  }
}

export async function AddComment(commnet: PersonelComment) {
  try {
    var user = new Cookies().get('user');
    const requestOptions = {
      method: "POST",
      url: BaseApi + 'hr/AddComment',
      data: commnet,
      headers: { 'Authorization': user.Token }
    };
    const response = await axios(requestOptions);
    return true;
  }
  catch (error) {
    console.error(error);
    return false;
  }
}




export async function GetItemsSurveyPersonels(): Promise<Array<SurveyItem>> {
  try {
    var user = new Cookies().get('user');
    const requestOptions = {
      headers: { 'Authorization': user.Token }
    };
    const response = await axios.get(BaseApi + 'HR/GetItemsSurveyPersonels', requestOptions);
    return response.data;
  }
  catch (error) {
    console.error(error);
    return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
  }
}


export async function SendPersonelSurveyItems(answers: any,comment:string) {
  try {
    var user = new Cookies().get('user');
    const requestOptions = {
      method: "POST",
      url: BaseApi + 'hr/SendPersonelSurveyItems?comment='+comment,
      data: answers,
      headers: { 'Authorization': user.Token }
    };
    const response = await axios(requestOptions);
    return true;
  }
  catch (error) {
    console.error(error);
    return false;
  }
}
